export const CLASS_NAMES = {
  pipeline: "flex flex-row gap-x-6 items-start justify-between",
};
